/**
 * Localization messages for Footer component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // Buttons
  'Save & Activate Role': 'roleRecs.footer.saveAndActivateRole',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type FooterMessage = keyof typeof invertedMessages;

export default invertedMessages;
